import { useSyncExternalStore } from "react";

// ブラウザのウィンドウの現在の幅
const getWindowWidth = () => {
  return window.innerWidth;
};
// ブラウザのウィンドウの現在の高さ
const getWindowHeight = () => {
  return window.innerHeight;
};

// ウィンドウのリサイズイベントにコールバックを登録し、解除する
const subscribeWindowSizeChange = (callback) => {
  window.addEventListener("resize", callback);
  return () => window.removeEventListener("resize", callback);
};

//ウィンドウの現在の幅と高さを監視し、オブジェクトとして返すカスタムフック
export const useWindowSize = () => {
  const width = useSyncExternalStore(subscribeWindowSizeChange, getWindowWidth);
  const height = useSyncExternalStore(
    subscribeWindowSizeChange,
    getWindowHeight
  );
  return { windowWidth: width, windowHeight: height };
};
